// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__vBeqT","rootCenter":"LoadMoreObserver_rootCenter__1z546","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__36fvS"};